import React from "react";
import Hiddenprojectinfo from "./Hiddenprojectinfo";
import { useState } from "react";
const MyProjectCard = ({ ele }) => {
  const { image, alt,   } = ele;
  const[projectinfo,setprojectinfo]=useState(false);
  return (
    <>
        <div className=" md:w-full w-[450px] min-h-[96px] h-fit  items-center justify-evenly flex flex-col py-4 px-3 cursor-pointer  rounded-2xl  shadow-whatcvbtn   shadow-sm " onClick={()=>{setprojectinfo(true)}} >
          <div className=" flex flex-col w-full rounded-2xl   h-72    py-2   ">
            <img
              src={image}
              alt={alt}
              className="text-black object-contain rounded-2xl w-full h-full "
            />
          </div>
        </div>
        <Hiddenprojectinfo projectinfo={projectinfo} setprojectinfo={setprojectinfo} ele={ele}/>
    </>
  );
};

export default MyProjectCard;
